import React from 'react'
import { FacebookIcon, GoogleIcon } from 'assets/icons'
// Assets
import Loading from 'assets/images/loading-white.svg'

const SocialButton = ({
  action,
  type,
  buttonText,
  loading,
  className = ''
}) => {
  const propsColor =
    type === 'FACEBOOK'
      ? 'bg-blue-900 focus:ring-blue-900'
      : 'bg-red-990 focus:ring-red-990'

  return (
    <button
      className={`${propsColor} rounded-full w-full py-3 px-4 flex flex-row justify-between content-center items-center focus:outline-none focus:ring-4 focus:transition-all focus:ring-opacity-50 transition-all hover:bg-purple-900 ${className}`}
      onClick={() => action()}
      type='button'
    >
      <span className=''>
        {
          {
            FACEBOOK: <FacebookIcon />,
            GOOGLE: <GoogleIcon />
          }[type]
        }
      </span>

      {!loading ? (
        <h2 className='antialiased leading-none text-center ml-3 text-white font-bold text-xs xl:text-base grow tracking-wide'>
          {buttonText}
        </h2>
      ) : (
        <div className='flex justify-center items-center w-full'>
          <img className='h-12 w-12' src={Loading} alt='Cargando...' />
        </div>
      )}
    </button>
  )
}

export default SocialButton
